import React, { useEffect, useState, useRef } from "react";
import LogoText from "../assets/images/logo/logotext.png";
import { Container, Row, Col } from 'react-bootstrap';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ExpressCheckoutElement, onConfirm } from '@stripe/react-stripe-js';
import { useCart, } from "../components/Cart";


// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_51QH4BlKtUcuZVWGk5tWx4sJr9jPfmJI9YNNKkF2BvMZ5Z41tQFkAHrWQmrdWmxSZDNiZGcwaC2rKifON42VcneUh00OOqqp6ru');

function Checkout({ setPageTitle }) {
    const options = {
        mode: 'payment',
        amount: 1099,
        currency: 'aed',
        automatic_payment_methods: {
            enabled: true,
        },
        // Customizable with appearance API.
        appearance: {/*...*/ },
    };

    const onClick = ({ resolve }) => {
        const options = {
            emailRequired: true
        };
        resolve(options);
    };

    useEffect(() => {
        setPageTitle("Checkout - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
            <Container className="py-5">
                <Row className="mb-5">
                    <Col lg={2}>
                        <img src={LogoText} className="img-fluid" />
                    </Col>
                </Row>
                <Row>
                    <Col lg={3} className="mx-auto">
                        <Elements stripe={stripePromise} options={options}>
                            <div id="checkout-page">
                                <ExpressCheckoutElement
                                    onClick={onClick}
                                    onConfirm={onConfirm}
                                />
                            </div>
                        </Elements>
                    </Col>
                    <Col lg={5} className="mx-auto">
                        <Col className="border rounded-3 border p-5"></Col>
                    </Col>
                </Row>
            </Container>

        </>

    );
};

export default Checkout;